import { CURRENCIES } from "@/constants/currency";
import { useLanguageAndCurrency } from "@/hooks/useLanguageAndCurrency";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { commonService } from "@/services/commonService";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { Button } from "./ui/Button";
import Spinner from "./ui/Spinner";

const MobileCurrencySelector = ({ onChangeComplete }) => {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    applyChanges,
    loading: currencyLoading,
    selectedCurrency,
    handleCurrencyChange,
  } = useLanguageAndCurrency();
  const t = useTranslationDetector();

  const getCurrencies = async () => {
    try {
      setLoading(true);
      const response = await commonService.getCurrencies();
      if (response?.Currencies) {
        setCurrencies(
          response.Currencies.map((currency) => ({
            value: currency.CurrencyCode,
            label: currency.CurrencyName,
            symbol: currency.CurrencySymbol,
          })),
        );
      } else {
        setCurrencies(
          Object.entries(CURRENCIES).map(([code, info]) => ({
            value: code,
            label: info.label,
            symbol: info.symbol,
          })),
        );
      }
    } catch (error) {
      console.error("MobileCurrencySelector: Error getting currencies:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getCurrencies();
  }, []);

  return loading ? (
    <div className="flex items-center justify-between p-4">
      <span className="flex items-center gap-2">
        <span>
          <FontAwesomeIcon
            icon={byPrefixAndName.fak["banknote"]}
            className="text-[20px]"
          />
        </span>
        <span>{t("common.loading")}</span>
      </span>
      <Spinner className="h-4 w-4 animate-spin" />
    </div>
  ) : (
    <div className="flex h-full flex-col justify-between">
      <div className="max-h-[360px] flex-1 overflow-y-auto px-4">
        {currencies.map((currency, index) => (
          <button
            key={currency.value}
            className={clsx("flex w-full items-center justify-between py-4")}
            onClick={() => handleCurrencyChange(currency.value)}
          >
            <span className="flex items-center gap-3">
              <span
                className={clsx(
                  "text-foreground border-border-strong flex h-6 w-6 items-center justify-center rounded-full border px-2 py-1 font-medium",
                  selectedCurrency === currency.value && "bg-primary border-0",
                )}
              >
                <span className="flex h-2 w-2 rounded-full bg-white"></span>
              </span>
              <span className="text-foreground font-medium">
                {currency.label}
              </span>
            </span>
            <span className="text-foreground inline-flex items-center gap-2 font-medium">
              <span>{currency.value}</span>
              <span className="h-[2px] w-[2px] rounded-full bg-black"></span>
              <span>{currency.symbol}</span>
            </span>
          </button>
        ))}
      </div>
      <div className="border-border-weaker border-t p-4">
        <Button
          className="w-full"
          size="lg"
          onClick={() => applyChanges(onChangeComplete)}
          loading={currencyLoading}
        >
          {t("languageandcurrency.save")}
        </Button>
      </div>
    </div>
  );
};

export default MobileCurrencySelector;
